import React from 'react'
import NewsList from '../news/NewsList'

const InformationView = () => {
  return (
    <div className='information'>
      <NewsList />
    </div>
  )
}

export default InformationView